export default {
  'menu.zuzhijiegou': '组织结构',
  'menu.jueseguanli': '角色管理',
  'menu.quanxianxiang': '权限项',
  'menu.miyao': 'API密钥',
  'menu.mobanguanli': '模版管理',
  'menu.yongyuji': '用语集',
  'menu.gerenzhongxin': '个人中心',
  'menu.xiugaimima': '修改密码',
  'menu.shenjirizhi': '审计日志',
  'menu.security': '安全设置',
  'menu.versionConfig': '版本配置',
  'menu.meetingTopicLimit': '会议主题限制',
  'menu.hotwords': '热词',
  'menu.chengyuandaoru': '成员导入',
  'menu.shuyuganYu': '术语干预管理',
  'menu.fankuishucai': '反馈素材管理',
  'menu.tongjibaobiao.fankuishucai': '反馈素材管理',
  'menu.tongjibaobiao': '统计报表',
  'menu.huiyibaobiao': '会议报表',
  'menu.tongjibaobiao.huiyibaobiao': '会议报表',

  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
